module.exports = __webpack_public_path__ + "static/media/rehau_grazio.f78c93fd.png";